module.exports = __webpack_public_path__ + "media/4.023c40ba.aac";